import { render, staticRenderFns } from "./VipBTabPage.vue?vue&type=template&id=210870bc&scoped=true&"
import script from "./VipBTabPage.vue?vue&type=script&lang=ts&"
export * from "./VipBTabPage.vue?vue&type=script&lang=ts&"
import style0 from "./VipBTabPage.vue?vue&type=style&index=0&id=210870bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210870bc",
  null
  
)

export default component.exports